module.exports = __webpack_public_path__ + "static/media/letter.a51f65ff.svg";